import { Translate, Localize, translate } from "react-i18nify";

export function displayLoginError(errorCode) {
  switch (errorCode) {
    case 400:
      return translate("application.kioskdetail.errors.unabletoprocesskey");
    case 401:
      return translate("application.errors.invalidcredentials");
    case 403:
      return translate("application.kioskdetail.errors.keyerror");
    case 404:
      return translate("application.errors.invalidcredentials");
    case 503:
      return translate("application.errors.serverunavailable");
    case "E0":
      return translate("application.errors.webaccessdisabled");
    default:
      return translate("application.errors.unknownerror");
  }
}

export function getErrorTranslateID(errorCode) {
  console.log("getErrorTranslateID, errorCode", errorCode);
  switch (errorCode) {
    case "":
    case null:
    case undefined:
      return "";
    case 400:
      return "application.kioskdetail.errors.unabletoprocesskey";
    case 401:
      return "application.errors.invalidcredentials";
    case 403:
      return "application.kioskdetail.errors.keyerror";
    case 404:
      return "application.errors.invalidcredentials";
    case 429:
      return "application.errors.toomanyrequests";
    case 503:
      return "application.errors.serverunavailable";
    case "E0":
      return "application.errors.webaccessdisabled";
    case "E1":
      return "application.submissionapproval.errors.overridekeyerror";
    default:
      return "application.errors.unknownerror";
  }
}

export function getTelephoneErrorTranslateID(errorCode) {
  console.log("getErrorTranslateID, errorCode", errorCode);
  switch (errorCode) {
    case "":
    case null:
    case undefined:
      return "";
    case 400:
      return "application.phonenumber.errors.unablefetchaccount";
    case 401:
      return "application.phonenumber.errors.invalidphone";
    case 403:
      return "application.kioskdetail.errors.keyerror";
    // case 404:
    //   return "application.errors.invalidcredentials";
    case 423:
      return "application.errors.webaccessdisabled";
    case 429:
      return "application.errors.toomanyrequests";
    case 503:
      return "application.errors.serverunavailable";
    case "E0":
      return "application.errors.webaccessdisabled";
    case "E1":
      return "application.submissionapproval.errors.overridekeyerror";
    default:
      return "application.errors.unknownerror";
  }
}
